import { Controller } from "remult";

@Controller("user-vehicle-methods")
export class UserVehicleMethods {}
